<template>
  <div class="font-modify" >
    <b-button variant="primary" @click="printPage" block>Print</b-button>
    <VueHtml2pdf
      ref="html2PdfExaminationTable"
      :show-layout="false"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="true"
      :filename="`${pationtData.patient.name} ${new Date().toLocaleDateString()}`"
      :pdf-quality="3"
      :manual-pagination="false"
      pdf-format="a4"
      :paginate-elements-by-height="1400"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
    >
      <section dir="ltr" class="pdf-content font-modify p-2" slot="pdf-content">
          <div
            class="border border-dark p-1"
            style="display: flex; justify-content: space-between"
          >
            <span>
              <p style="background-color: white">
                Name:
                <span v-if="pationtData.patient">
                  {{ pationtData.patient.name }}</span
                >
              </p>
              Sex:
              <span v-if="pationtData.patient">
                {{ pationtData.patient.gender }}</span
              >
            </span>
            <span>
              <p dir="rtl">
                عنوان المريض :
                <span v-if="pationtData.patient">
                  {{ pationtData.patient.city_name }}</span
                >
              </p>
            </span>
          </div>
          <div
            class="border border-dark p-1"
            style="display: flex; justify-content: space-between"
          >
            <span>
              <p
                style="background-color: white"
                class="flex align-items-center"
              >
                Age:
                <span v-if="pationtData.patient">
                  {{ calculateAge(pationtData.patient.birth_date) }}</span
                >
              </p>
            </span>
            <span>
              <p dir="rtl">
                مهنة المريض :
                <span v-if="pationtData.patient">
                  {{ pationtData.patient.occupation }}</span
                >
              </p>
            </span>
          </div>
          <div
            class="border border-dark p-1"
            style="display: flex; justify-content: end"
          >
            <span>
              <p dir="rtl">
                اقرب شخص له:
                <span v-if="pationtData.next_of_kin_name">
                  {{ pationtData.next_of_kin_name }}</span
                >
                -
                <span v-if="pationtData.next_of_kin_phone_number">
                  {{ pationtData.next_of_kin_phone_number }}</span
                >
              </p>
            </span>
          </div>
          <table
            class="mb-3 border border-dark"
            style="width: 100%; table-layout: fixed"
          >
            <tr style="height: 115px; border: none">
              <th rowspan="2" style="vertical-align: top">
                <p class="mx-2">
                  History:

                  <span v-if="pationtData.created_at">
                    {{ pationtData.patient.created_at }}</span
                  >
                </p>
              </th>
              <th class="border border-dark" style="vertical-align: top">
                <p class="mx-2">Diagnosis:</p>
                <span v-if="pationtData.diagnosis">
                  {{ pationtData.diagnosis }}</span
                >
              </th>
              <th class="border border-dark" style="vertical-align: top">
                <p class="mx-2">Investigation:</p>
                <span v-if="pationtData.investigation">
                  {{ pationtData.investigation }}</span
                >
              </th>
            </tr>
            <tr style="height: 115px; border: none">
              <th
                class="border border-dark"
                rowspan="2"
                style="vertical-align: top"
              >
                <p class="mx-2">Examination:</p>
                <span v-if="pationtData.examination">
                  {{ pationtData.examination }}</span
                >
              </th>
              <th class="border border-dark" style="vertical-align: top">
                <p class="mx-2">Drug Allergy:</p>
              </th>
            </tr>
            <tr
              class="border-top border-dark"
              style="height: 115px; border: none"
            >
              <th rowspan="2" style="vertical-align: top">
                <p class="mx-2">Systematic Illness:</p>
              </th>
              <th style="vertical-align: top">
                <p class="mx-2">Treatment:</p>
                <span v-if="pationtData.treatment">
                  {{ pationtData.treatment }}</span
                >
              </th>
            </tr>
          </table>

          <div
            v-if="newVitalSignData.length > 0"
            class="d-flex justify-content-between"
          >
            <table class="border border-dark" style="width: 48%">
              <thead>
                <tr>
                  <th class="border border-dark p-1">Temperature Date</th>
                  <th class="border border-dark p-1">Temperature</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="temp in (newVitalSignData &&
                    newVitalSignData[0] &&
                    newVitalSignData[0].vitals) ||
                  []"
                  :key="temp.id"
                  class="border border-dark"
                >
                  <td class="border border-dark text-center">
                    {{ formatDate(temp.date) }}
                  </td>
                  <td class="border border-dark text-center">{{ temp.value }}°C</td>
                </tr>
              </tbody>
            </table>

            <table class="border border-dark" style="width: 48%">
              <thead>
                <tr>
                  <th class="border border-dark p-1">Pulse Date</th>
                  <th class="border border-dark p-1">Pulse</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="pulse in (newVitalSignData &&
                    newVitalSignData[1] &&
                    newVitalSignData[1].vitals) ||
                  []"
                  :key="pulse.id"
                  class="border border-dark"
                >
                  <td class="border border-dark text-center">
                    {{ formatDate(pulse.date) }}
                  </td>
                  <td class="border border-dark text-center">{{ pulse.value }} bpm</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Add Prescription Tables -->
          <div
            v-if="data.length > 0"
            class="page-break"
            style="padding-top: 10px"
          >
            <div
              v-for="prescription in data"
              :key="prescription.id"
              class="mt-3 page-break"
            >
              <div class="prescription-details mb-3">
                <h5 class="mb-2">Prescription Details</h5>
                <div class="prescription-info">
                  <div class="info-item">
                    <strong>Drug:</strong>
                    <strong class="text-primary mr-2">{{ prescription.source_of_drug === 'pharmacy' ? prescription.drug_scientific_name.name : '' }}</strong>
                    <span>{{ prescription.item ? getNestedProperty(prescription, "item.name") : prescription.item_name }}</span>
                    <span v-if="!prescription.item" class="text-danger ml-1">({{ $t("common.item_is_external") }})</span>
                  </div>
                  <div class="info-item">
                    <strong>Type:</strong> {{ prescription.type }}
                  </div>
                  <div class="info-item">
                    <strong>Dose:</strong> {{ prescription.dose }}
                  </div>
                  <div class="info-item">
                    <strong>Duration Between Doses:</strong>
                    {{ prescription.duration_between_doses }}
                  </div>
                  <div class="info-item">
                    <strong>Number of Doses:</strong>
                    {{ prescription.number_of_doses }}
                  </div>
                  <div class="info-item description">
                    <strong>Description:</strong>
                    <pre class="description-text">{{ prescription.description || "-" }}</pre>
                  </div>
                </div>
              </div>
              <table class="border border-dark w-100">
                <thead>
                  <tr>
                    <th class="border border-dark p-1">Time</th>
                    <th class="border border-dark p-1">Quantity</th>
                    <th class="border border-dark p-1">Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="schedule in prescription.patient_card_drug_table"
                    :key="schedule.id"
                    class="border border-dark"
                  >
                    <td class="border border-dark text-center">
                      {{ formatDate(schedule.time) }}
                    </td>
                    <td class="border border-dark text-center">
                      {{ schedule.quantity }}
                    </td>
                    <td class="border border-dark text-center">
                      {{ schedule.description || "-" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
      </section>
    </VueHtml2pdf>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import VueHtml2pdf from "vue-html2pdf";
import { BButton } from "bootstrap-vue";

export default defineComponent({
  components: {
    VueHtml2pdf,
    BButton,
  },
  props: ["data", "newVitalSignData"],
  data() {
    return {
      pationtData: {},
    };
  },
  mounted() {
    this.getPationtData();
  },

  methods: {
    printPage() {
      this.$refs.html2PdfExaminationTable.generatePdf();
    },

    async getPationtData() {
      const url = `/patientCard/${this.$route.params.id}`;

      await this.getList(url);
      this.pationtData = this.all_data;
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    calculateAge(birthDatee) {
      const today = new Date();
      const birthDate = new Date(birthDatee);
      let age = today.getFullYear() - birthDate.getFullYear();
      return age;
    },
  },
});
</script>
<style >
.font-modify {
  letter-spacing: normal !important;
  color: black;
}
.page-break {
  break-inside: avoid !important;
  page-break-inside: avoid !important;
}
.prescription-details {
  border: 1px solid #dee2e6;
  padding: 1rem;
  border-radius: 4px;
}

.prescription-info {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 0.75rem;
}

.info-item {
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.info-item.description {
  grid-column: 1 / -1;
}

.description-text {
  margin: 0.5rem 0 0 0;
  white-space: pre-wrap;
  font-family: inherit;
  background-color: white;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}
</style>
